import { Text } from '@mantine/core';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Box, Container } from '@/DesignSystem/Component';
import { useShadUser } from '@/Module/Auth/Hook';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
const AuthMultiDeviceLogout = () => {
  const isShadUser = useShadUser();
  const [timer, setTimer] = useState(1);
  const progressPercentageRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const result = router.query?.result as string || '';
  const message: Record<string, string> = {
    401: 'شما با دستگاه دیگری وارد حساب کاربری خود شده‌اید.',
    duplicate_login: 'شما با دستگاه دیگری وارد حساب کاربری خود شده‌اید.',
    refresh_token_expired: 'شما مدت زیادی از آی‌نو استفاده نکرده‌اید و نیاز است مجدداً وارد سیستم شوید.',
    inactive_user: 'حساب کاربری شما غیرفعال شده است. لطفاً با پشتیبانی تماس بگیرید.',
    no_refresh_token: 'برای دسترسی به این سرویس، نیاز است وارد سیستم شوید.',
    something_went_wrong: 'مشکلی پیش آمده است و نیاز است مجدداً وارد سیستم شوید.'
  };
  useEffect(() => {
    if (timer >= 10) {
      if (isShadUser) {
        router.replace({
          pathname: LINKS.AUTH.LOGIN,
          query: {}
        });
      } else if (result === 'no_refresh_token') {
        router.replace({
          pathname: LINKS.AUTH.LOGIN,
          query: {}
        });
      } else {
        router.replace({
          pathname: LINKS.HOME,
          query: {}
        });
      }
    }
    const progressTimer = setTimeout(() => {
      if (progressPercentageRef.current) {
        progressPercentageRef.current.style.width = `${(timer / 10 * 100).toFixed(2)}%`;
        setTimer(prev => prev + 1);
      }
    }, 1000);
    return () => {
      clearTimeout(progressTimer);
    };
  }, [timer]);
  return <Container className="max-w-3xl" data-sentry-element="Container" data-sentry-component="AuthMultiDeviceLogout" data-sentry-source-file="index.tsx">
      <Box color="secondary" className="m-10 flex h-full flex-col justify-between border-4 border-blueFour bg-blueOne bg-grade-description bg-right-bottom bg-no-repeat p-5 sm:p-6" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Text fw="bold" c="#0E4791" size="lg" className="mb-2 md:mb-0" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          <span className="hidden md:flex">از حساب خود خارج شدید!</span>
          <span className="flex md:hidden">از آی‌نو خارج شدید!</span>
        </Text>
        <Text fw="normal" c="#0E4791" className="text-justify text-xs md:mb-2 md:text-lg" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {message[result] ?? message.something_went_wrong}
        </Text>
        <div className="mt-5 flex w-full items-center justify-center">
          <Image src={`${FILE_BROWSER_URL}/img/login-limitation-popup.svg`} alt="محدودیت ورود به حساب" width={260} height={260} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </div>

        <div className="mt-5 flex flex-col items-center justify-center">
          <Text fw="normal" c="#0E4791" className="my-2 flex flex-row justify-start gap-1 text-xs md:gap-2 md:text-lg" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            <span className="hidden md:flex">تا</span>
            <span className="w-2 font-bold text-red-500 md:w-3">{11 - timer}</span>
            <span>ثانیه دیگر از صفحه خارج می&zwnj;شوید.</span>
          </Text>
          <div className="min-w-full rounded-full bg-blueTwo ">
            <div className="w-0 rounded-full  bg-blueFive p-1 transition-all duration-1000" ref={progressPercentageRef} />
          </div>
        </div>
      </Box>
    </Container>;
};
export default AuthMultiDeviceLogout;